module.exports = __webpack_public_path__ + "img/feedback_timeout.a4aeaa74.gif";